import React, { useEffect } from 'react';

import { Status } from '@prometheus/types';
import {
  EmptyTableStub,
  Grid,
  Spinner,
  Typography,
} from '@prometheus/components';

import {
  SpinnerWidgetContainer,
  HomePageWidgetList,
  HomePageWidgetListItem,
} from '@prometheus/features';

import { useNavigate } from 'react-router-dom';
import { useList } from '@prometheus/hooks';
import { getCdmDataSourcesList } from '@/api';

export const LastCreatedDataSources: React.FC<any> = props => {
  const { t } = props;
  const navigate = useNavigate();

  const {
    data: list,
    status,
    getEntityList,
  } = useList({
    methods: {
      read: {
        // we need to use  {sortBy: { id: 'modified.timestamp', desc: true }}  as soon as BE ready
        method: () => getCdmDataSourcesList({}),
      },
    },
  });

  useEffect(() => {
    getEntityList();
  }, [getEntityList]);

  if (
    status === Status.INITIAL ||
    status === Status.IN_PROGRESS ||
    status === Status.IN_PROGRESS_RELOAD
  ) {
    return (
      <SpinnerWidgetContainer>
        <Spinner size={32} />
      </SpinnerWidgetContainer>
    );
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="h3" fontWeight={700} fontSize={15}>
          {t('modules.data_sources.header')}
        </Typography>
      </Grid>
      <HomePageWidgetList>
        {status === Status.SUCCESS &&
          (Object.values(list.byId)?.length ? (
            Object.values(list.byId)
              .slice(0, 5)
              .map(item => {
                return (
                  <HomePageWidgetListItem
                    key={item.id + 'favorite'}
                    onClick={() => {
                      navigate('/admin/databases/' + item.id);
                    }}
                  >
                    <div className="list-item-section nowrap">
                      <div className="list-item-title" title={item.name}>
                        {item.name}
                      </div>
                    </div>
                  </HomePageWidgetListItem>
                );
              })
          ) : (
            <HomePageWidgetListItem light>
              <EmptyTableStub
                noDataText={t('modules.submissions.no_data_text')}
                addButtonText={t('modules.submissions.go_to')}
                onAdd={() => navigate('/submissions')}
              />
            </HomePageWidgetListItem>
          ))}
        {status === Status.ERROR && (
          <HomePageWidgetListItem light>
            <EmptyTableStub
              noDataText={t('modules.data_sources.failed_load')}
              addButtonText=""
            />
          </HomePageWidgetListItem>
        )}
      </HomePageWidgetList>
    </Grid>
  );
};
